

// new with company plus admin data
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./style.css";

const AdminProfile = () => {
  const [profile, setProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [updateMsg, setUpdateMsg] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const adminid =
        Cookies.get("sessionidadmin") || "";

      if (!adminid) {
        setIsLoading(false);
        return;
      }

      const response = await fetch(
        "https://api.terraweb.africa/loadProfileAdmin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            adminid,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        setProfile(result.data);
      }

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  const handleUpdatePassword = async () => {
    const adminid =
      Cookies.get("sessionidadmin") || "";

    if (!adminid) return;

    if (
      !currentPassword ||
      !newPassword ||
      !confirmPassword
    ) {
      setUpdateMsg(
        "Please fill all password fields"
      );
      return;
    }

    if (newPassword !== confirmPassword) {
      setUpdateMsg(
        "New password and confirm password do not match"
      );
      return;
    }

    try {
      setIsUpdating(true);
      setUpdateMsg("");

      const response = await fetch(
        "https://api.terraweb.africa/update",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: adminid,
            email: profile?.email,
            password: currentPassword,
            newpass: newPassword,
            confirmPass: confirmPassword,
          }),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result);
      }

      setUpdateMsg(
        "✅ Password updated successfully"
      );

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error(err);

      setUpdateMsg(
        "❌ Unable to update password. Try again later."
      );
    } finally {
      setIsUpdating(false);
    }
  };

  if (isLoading) {
    return (
      <div className="tc mt5">
        <div className="loader">
          Loading profile...
        </div>
      </div>
    );
  }

  const initials =
    profile?.company
      ?.split(" ")
      .map((x) => x[0])
      .join("")
      .slice(0, 2)
      .toUpperCase() || "TW";

  return (
    <div className="admin-profile-wrapper mt6">
      <div className="co-container">

        {/* Sidebar */}
        <div className="profile-sidebar">

          <div
            style={{
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              backgroundColor: "#fc9c1c",
              color: "#fff",
              fontWeight: "700",
              fontSize: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 15px",
            }}
          >
            {initials}
          </div>

          <h3 className="username">
            {profile?.username}
          </h3>

          <p className="email">
            Company Administrator
          </p>

          <div className="profile-info">
            <p>
              <span>Company:</span>{" "}
              {profile?.company}
            </p>

            <p>
              <span>Status:</span>{" "}
              {profile?.status || "Active"}
            </p>

            <p>
              <span>Industry:</span>{" "}
              {profile?.industry}
            </p>

            <p>
              <span>Location:</span>{" "}
              {profile?.location}
            </p>
          </div>
        </div>

        {/* Admin Profile */}
        <div className="profile-settings">
          <h4>Administrator Profile</h4>

          <div className="form-group">
            <label>Username</label>
            <input
              disabled
              value={profile?.username || ""}
            />
          </div>

          <div className="form-group">
            <label>Full Name</label>
            <input
              disabled
              value={profile?.fullname || ""}
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              disabled
              value={profile?.email || ""}
            />
          </div>

          <div className="form-group">
            <label>Phone</label>
            <input
              disabled
              value={profile?.phone || ""}
            />
          </div>

          <div className="form-group">
            <label>Gender</label>
            <input
              disabled
              value={profile?.gender || ""}
            />
          </div>

          <div className="form-group">
            <label>Role</label>
            <input
              disabled
              value={profile?.category || ""}
            />
          </div>
        </div>

        {/* Company + Password */}
        <div className="profile-settings">
          <h4>Company Information</h4>

          <div className="form-group">
            <label>Company Name</label>
            <input
              disabled
              value={profile?.company || ""}
            />
          </div>

          <div className="form-group">
            <label>Industry</label>
            <input
              disabled
              value={profile?.industry || ""}
            />
          </div>

          <div className="form-group">
            <label>Total Users</label>
            <input
              disabled
              value={profile?.totalUsers || 0}
            />
          </div>

         

          <hr />

          <h4>Change Password</h4>

          <div className="form-group">
            <label>Current Password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) =>
                setCurrentPassword(
                  e.target.value
                )
              }
            />
          </div>

          <div className="form-group">
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) =>
                setNewPassword(
                  e.target.value
                )
              }
            />
          </div>

          <div className="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) =>
                setConfirmPassword(
                  e.target.value
                )
              }
            />
          </div>

          <div className="btn-container">
            <button
              onClick={handleUpdatePassword}
              disabled={isUpdating}
            >
              {isUpdating
                ? "Updating..."
                : "Update Password"}
            </button>
          </div>

          {updateMsg && (
            <div className="resend-msg mt2">
              {updateMsg}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;